import * as jose from 'jose';

import { createHTTPError, Logger } from '@gitbook/util-debug';

import { AUTH_AUDIENCE, AUTH_ISSUER } from './config';
import type { AuthenticationTokenPayload } from './types';

const logger = Logger('hive:authentication');

/**
 * Verify and decode an authentication token.
 */
export async function verifyAuthToken(
    jwtToken: string,
    secretStr: string
): Promise<AuthenticationTokenPayload> {
    if (!secretStr) {
        throw new Error(
            'Missing secret for authentication verification. Hive might be misconfigured.'
        );
    }

    const secret = new TextEncoder().encode(secretStr);

    let token: jose.JWTVerifyResult;
    try {
        token = await jose.jwtVerify(jwtToken, secret, {
            issuer: AUTH_ISSUER,
            audience: AUTH_AUDIENCE,
        });
    } catch (err) {
        const message =
            err instanceof jose.errors.JOSEError
                ? `Invalid authentication token ${err.code} ${err.message}`
                : `Invalid authentication token ${err instanceof Error ? err.message : String(err)}`;
        // Log handled vs unhandled errors differently.
        const level = err instanceof jose.errors.JWTExpired ? 'warning' : 'error';
        logger[level](message);

        throw new createHTTPError.Unauthorized(`Invalid authentication token`);
    }

    // @ts-ignore
    return token.payload as AuthenticationTokenPayload;
}
